import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusSection() {
  const bonos = [{
    id: '01',
    title: 'KIT EXPRESS DE PROMPTS RELLENABLES',
    desc: '20 plantillas listas para completar y ejecutar en IA en menos de 10 minutos.',
    value: '$15.000'
  }, {
    id: '02',
    title: 'CHECKLIST DE LANZAMIENTO RÁPIDO META ADS',
    desc: 'Todo lo que tenés que verificar antes, durante y después de publicar tu campaña.',
    value: '$12.000'
  }, {
    id: '03',
    title: 'MAPA DE 50 ÁNGULOS DE ANUNCIOS RENTABLES',
    desc: 'Del mismo producto, infinitas campañas. Nunca más repetir el mismo anuncio.',
    value: '$14.000'
  }, {
    id: '04',
    title: 'BANCO DE 100 GANCHOS PARA DETENER EL SCROLL',
    desc: 'Las primeras líneas que hacen que tu anuncio sea imposible de ignorar en el feed.',
    value: '$13.000'
  }, {
    id: '05',
    title: 'PLANNER SEMANAL DEL MEDIA BUYER EFICIENTE',
    desc: 'Organizá tu semana para ejecutar más rápido y recuperar horas cada semana.',
    value: '$11.000'
  }, {
    id: '06',
    title: 'MATRIZ RÁPIDA DE DIAGNÓSTICO DE CAMPAÑAS',
    desc: 'Del síntoma a la causa real en minutos. Sin adivinar. Sin cambios al azar.',
    value: '$12.000'
  }];
  return <section className="py-12 px-4 max-w-5xl mx-auto" data-id="element-28">
      <FadeIn data-id="element-29">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-30">
          <span className="text-4xl" data-id="element-31">🎁</span> 6 BONOS ESTRATÉGICOS — SIEMPRE
          INCLUIDOS
        </h2>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-32">
        <div className="overflow-x-auto rounded-xl border border-gray-800 bg-gray-900/50" data-id="element-33">
          <table className="w-full text-left border-collapse" data-id="element-34">
            <thead data-id="element-35">
              <tr className="bg-gray-800/80 border-b border-gray-700" data-id="element-36">
                <th className="p-4 font-bold text-gray-400 w-16 text-center" data-id="element-37">
                  #
                </th>
                <th className="p-4 font-bold text-gray-200" data-id="element-38">Bono</th>
                <th className="p-4 font-bold text-gray-400 text-right" data-id="element-39">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody data-id="element-40">
              {bonos.map((bono, index) => <tr key={index} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors" data-id="element-41">
                  <td className="p-4 text-center font-mono text-green-500 font-bold" data-id="element-42">
                    {bono.id}
                  </td>
                  <td className="p-4 text-gray-200" data-id="element-43">
                    <p className="font-bold mb-1" data-id="element-44">{bono.title}</p>
                    <p className="text-sm text-gray-400" data-id="element-45">{bono.desc}</p>
                  </td>
                  <td className="p-4 text-right align-top" data-id="element-46">
                    <div className="flex flex-col items-end" data-id="element-47">
                      <span className="text-red-400 line-through text-sm" data-id="element-48">
                        {bono.value}
                      </span>
                      <span className="text-green-400 font-black" data-id="element-49">GRATIS</span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center bg-green-900/20 border border-green-500/30 rounded-xl p-6" data-id="element-50">
          <p className="text-2xl font-bold" data-id="element-51">
            Valor total bonos:{' '}
            <span className="text-red-400 line-through mx-2" data-id="element-52">$77.000</span>
            <span className="text-green-400" data-id="element-53">→ GRATIS con tu MegaPack</span>
          </p>
        </div>
      </FadeIn>
    </section>;
}